import React from 'react'
import { SHOP_SETTING_KEY } from '../../../const';
import AddProductExcelV1 from './AddProductExcelV1';
import AddProductManagement from './AddProductManagement';

function AddProductExcel() {
    //get shop data from localStorage
    const setting = JSON.parse(localStorage.getItem(SHOP_SETTING_KEY));
    return (
        <>
        {
            setting?.stockInOut ? (
                <AddProductManagement />
            ) : (
                <AddProductExcelV1 />
            )
        }
        </>
    )
}

export default AddProductExcel